import StvSelbstbeteiligung, { getGoogleTagManagerSbValue } from '../consumer/form/dto/StvSelbstbeteiligung';
import StvVersicherungssumme, { getGoogleTagManagerVsValue } from '../consumer/form/dto/StvVersicherungssumme';
import StvZahlungsweise, { getGoogleTagManagerZwValue } from '../consumer/form/dto/StvZahlungsweise';
import BrowserDetection from '../app/util/BrowserDetection';
import GtmFormulareingabeField from './types/GtmFormulareingabeField';
import GtmPageviewTitleId from './types/GtmPageviewTitleId';


const fireEvent = (data: object) => {
    try {
        window.dataLayer.push(data);
    } catch (error) { }
}

const fireEventAppInit = (vmnrVorh: boolean, partnernrVorh: boolean) => {
    const agentInfo = BrowserDetection.createUserAgentInfo()

    const eventData = {
        event: 'rhld_appinit',
        rhld: {
            partner: {
                vmnrVorh,
                kundennrVorh: partnernrVorh
            },
            userAgent: {
                browser: {
                    name: agentInfo.browser.name,
                    version: agentInfo.browser.version
                },
                plattformType: agentInfo.plattformType,
                os: {
                    name: agentInfo.os.name,
                    version: agentInfo.os.version
                }
            }
        }
    }
    fireEvent(eventData);
}


const fireEventBtnAntragEinreichen = () => {
    const eventData = {
        event: 'rhld_btnAntragEinreichen',
    }

    fireEvent(eventData);
}

const fireEventBtnDokumenteAnfordern = () => {
    const eventData = {
        event: 'rhld_btnDokumenteAnfordern',
    }

    fireEvent(eventData);
}

const fireEventBtnInfo = (btnInfo: string) => {
    const eventData = {
        event: 'rhld_btnInfo',
        rhld: {
            btnInfo
        }
    }

    fireEvent(eventData);
}


const fireEventFormularfeld = (fieldId: string) => {
    const eventData = {
        event: 'rhld_formularfeld',
        rhld: {
            formularfeld: fieldId
        }
    }

    fireEvent(eventData);
}

const fireEventPageview = (title: GtmPageviewTitleId) => {
    const eventData = {
        event: 'rhld_pageview',
        rhld: {
            pageview: title
        }
    }

    fireEvent(eventData);
}

const fireEventTarifierung = (produktMitSchutzbrief?: boolean,
    sb?: StvSelbstbeteiligung,
    vs?: StvVersicherungssumme,
    zw?: StvZahlungsweise) => {

    const sbGtm = getGoogleTagManagerSbValue(sb);
    const vsGtm = getGoogleTagManagerVsValue(vs);
    const zwGtm = getGoogleTagManagerZwValue(zw);

    const eventData = {
        event: 'rhld_tarifierung',
        rhld: {
            tarifierung: {
                produktMitSchutzbrief,
                sb: sbGtm,
                vs: vsGtm,
                zahlungsweise: zwGtm
            }
        }
    }

    fireEvent(eventData);
}



const fireEventFormulareingabe = (field: GtmFormulareingabeField, wert: string) => {
    const eventData = {
        event: 'rhld_formulareingabe',
        rhld: {
            formulareingabe: {
                field,
                wert
            }
        }
    }

    fireEvent(eventData);
}

const GoogleTagManager = {
    fireEventAppInit,
    fireEventPageview,
    fireEventFormulareingabe,
    fireEventFormularfeld,
    fireEventBtnInfo,
    fireEventBtnDokumenteAnfordern,
    fireEventBtnAntragEinreichen,
    fireEventTarifierung
}

export default GoogleTagManager;